/**
 * .c-textarea を全て取得して
 * 文字数カウンターのセットと、カウントを実行します
 * @returns { void }
 */
export const textarea = () => {
  {
    const elements = document.querySelectorAll( '.c-textarea' );

    elements.forEach( element => {
      const length      = element.value.length;
      const maxlength   = element.getAttribute( 'maxlength' );
      const addHtml     = `<div class="c-textarea__counter c-text-m">
                            <span class="js-textareaCounter">${ length }</span>/${ maxlength }
                          </div>`;
      const addClass    = element.classList.contains( 'c-textarea--large' ) ? 'c-textarea__wrapper--large' : '';

      element.outerHTML = `<div class="c-textarea__wrapper ${ addClass }">` + element.outerHTML + addHtml + '</div>';
    } );
  }

  {
    const elements = document.querySelectorAll( '.c-textarea' );

    elements.forEach( element => {
      const typingEvents = 'keyup,focusout'.split( ',' );
      typingEvents.forEach( eventName => {
        element.addEventListener( eventName, function () {
          const counterEl  = this.parentElement.querySelector( '.js-textareaCounter' );
          counterEl.innerHTML = this.value.length;
        } );
      } );
    } );
  }
}
